import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetFormDto } from "src/http/types";
import { useAccessToken } from "src/http/use-access-token";
import { queryKeys } from "../queryKeys";

const useGetFormRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getFormRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.forms.getForm>>): Promise<GetFormDto> {
    const accessToken = await getAccessToken();
    const [{ guid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/forms/${guid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getFormRequest };
};

const useGetForm = (guid: string | undefined) => {
  const { getFormRequest } = useGetFormRequest();

  return useQuery({
    queryKey: queryKeys.forms.getForm(guid),
    queryFn: getFormRequest,
    enabled: guid !== undefined,
  });
};

export { useGetForm };
